<template>
  <com-page>
    <com-search :columns="searchColumn" @search="handleSearch"></com-search>
    <com-card>
      <!-- <div class="mb-20px flex justify-end">
        <el-button type="primary" @click="handleExport">导出</el-button>
        <el-button type="primary" @click="handleCreated">添加商家</el-button>
      </div> -->
      <com-table :columns="columns" :api="api" ref="tableRef">
        <template #createTime="row">
          {{ row.data.createTime | formatDate }}
        </template>
        <template #operation="row">
          <el-button type="primary" @click="handleCheck(row.data)" size="mini" class="mb-5rpx"
            >查看</el-button
          >
          <el-button type="primary" @click="handleEdit(row.data)" size="mini" class="mb-5rpx"
            >编辑</el-button
          >
          <el-button type="danger " @click="handleDel(row.data)" class="mb-5rpx" size="mini"
            >删除</el-button
          >
        </template>
        <template #status="row">
          <el-switch
            v-model="row.data.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatus(row.data)"
          >
          </el-switch>
        </template>
      </com-table>
    </com-card>
    <!-- <the-add-shop ref="shopRef" @success="update"></the-add-shop> -->
  </com-page>
</template>

<script>
import { listApi, delBusinessApi, businessStatusApi } from '@/api/business'
import { exportExcel } from '@/utils/index'
import { formatDate } from '@/filters'
// import theAddShop from './components/the-add-shop'

export default {
  // components: { theAddShop },
  data() {
    return {
      api: listApi,
      searchColumn: [
        {
          label: '商家名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '联系人',
          prop: 'contact',
          type: 'input'
        },
        {
          label: '联系电话',
          prop: 'phone',
          type: 'input'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'select',
          option: [
            {
              label: '正常',
              value: 1
            },
            {
              label: '冻结',
              value: 0
            }
          ]
        }
      ],
      columns: [
        {
          label: '商家编号',
          prop: 'number',
          width: '150'
        },
        {
          label: '商家名称',
          prop: 'name',
          minWidth: '150'
        },
        {
          label: '商家地址',
          prop: 'address',
          auto: true
        },
        {
          label: '联系人',
          prop: 'contact',
          minWidth: '120'
        },
        {
          label: '联系电话',
          prop: 'phone',
          width: '150'
        },
        {
          label: '关联网点数',
          prop: 'storeCount',
          width: '100'
        },
        {
          label: '设备数',
          prop: 'deviceCount'
        },
        {
          label: '订单量',
          prop: 'orderCount'
        },
        {
          label: '分成收入',
          prop: 'divideIncome',
          width: '100'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: '180'
        },
        {
          label: '操作',
          prop: 'operation',
          slotName: 'operation',
          type: 'slot',
          minWidth: '180',
          fixed: 'right'
        }
      ],
      exportQuery: {
        pageIndex: 1,
        pageSize: 10000
      }
    }
  },
  methods: {
    update() {
      this.$refs.tableRef.getList()
    },
    handleCreated() {
      const param = {
        type: 'created'
      }
      this.$refs.shopRef.open(param)
    },
    handleEdit(row) {
      const param = {
        type: 'edit',
        row
      }
      this.$refs.shopRef.open(param)
    },
    handleCheck(row) {
      this.$router.push({ name: 'shop-detail', params: row })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该商家, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            code: row.code
          }
          delBusinessApi(param).then(() => {
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    handleStatus(val) {
      const param = {
        status: val.status,
        code: val.code
      }
      businessStatusApi(param).then(() => {
        this.update()
      })
    },
    handleSearch(val) {
      console.log('handleSearch :>> ', val)
      this.exportQuery = { pageIndex: 1, pageSize: 10000, ...val }
      this.$refs.tableRef.search(val)
    },
    handleExport() {
      this.$message.info('请稍等,正在导出...')
      listApi(this.exportQuery).then((res) => {
        const { records } = res.data
        // eslint-disable-next-line prefer-const
        let newArr = []
        records.forEach((item) => {
          const params = {
            商家编号: item.number,
            商家名称: item.name,
            商家地址: item.address,
            联系人: item.contact,
            联系电话: item.phone,
            关联网点数: item.storeCount,
            设备数: item.deviceCount,
            订单量: item.orderCount,
            分成收入: item.divideIncome,
            状态: item.status === 1 ? '正常' : '冻结',
            创建时间: formatDate(item.createTime)
          }
          newArr.push(params)
        })
        exportExcel(newArr, '商家列表')
      })
    }
  }
}
</script>
